<template>
  <div class="col-md-4">
    <b-card class="mb-3">
      <b-card-text
        v-if="nextAppointment.appointmentDate"
        class="d-flex flex-row align-items-center justify-content-between"
      >
        <h6 class="font-weight-bold">{{ $t("dashboard.nextAppoinment") }}</h6>
        <button
          v-if="!loading"
          type="button"
          class="btn btn-checkedin"
          :class="{
            'btn-success': nextAppointment.checkedIn,
            'btn-outline-success': !nextAppointment.checkedIn
          }"
          v-on:click="checkNextAppointment"
        >
          <i class="fas fa-check mr-1"></i> Check
          {{ nextAppointment.checkedIn ? "Out" : "In" }}
        </button>
        <b-spinner
          v-if="loading"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </b-card-text>

      <b-card-text v-if="nextAppointment.appointmentDate == ''">
        <h5>NO UPCOMING</h5>
      </b-card-text>

      <b-card-text v-else>
        <div class="d-flex flex-row justify-content-between">
          <h5>
            {{ nextAppointment.appointmentDate | formatDateOnly }}
          </h5>
          <b-icon
            class="h1 ml-1 mr-1"
            icon="clock-fill"
            variant="warning"
          ></b-icon>
          <h5>
            {{ nextAppointment.appointmentDate | formatTimeOnly }}
          </h5>
        </div>
        <div class="d-flex flex-row align-items-center">
          <button
            v-if="
              nextAppointment.teamsMeetingUrl !== undefined ||
                (nextAppointment.zoomMeetingUrl !== undefined && !loading)
            "
            type="button"
            class="btn btn-link gap-appointments"
            v-on:click="joinTelehealthSession"
          >
            <i class="fas mr-1"></i> Join Telehealth Session
          </button>
        </div>
      </b-card-text>
    </b-card>

    <b-card>
      <b-card-text
        class="d-flex flex-row align-items-center justify-content-between"
      >
        <h6 class="font-weight-bold">{{ $t("dashboard.lastAppoinment") }}</h6>
        <i
          class="fas fa-check mr-1"
          :class="{
            'check-success': !lastAppointment.checkedIn,
            'btn-outline-success': lastAppointment.checkedIn
          }"
        ></i>
      </b-card-text>

      <b-card-text v-if="lastAppointment.appointmentDate == ''">
        <h5>NO APPOINTMENTS</h5>
      </b-card-text>

      <b-card-text v-else>
        <div class="d-flex flex-row justify-content-between">
          <h5>
            {{ lastAppointment.appointmentDate | formatDateOnly }}
          </h5>
          <b-icon
            class="h1 ml-1 mr-1"
            icon="clock-fill"
            variant="success"
          ></b-icon>
          <h5>
            {{ lastAppointment.appointmentDate | formatTimeOnly }}
          </h5>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import scheduleEvent from "../../server/scheduleEvents";
import { billingServer } from "../../server/billing";
export default {
  name: "HomeAppointments",
  data() {
    return {
      loading: false
    };
  },
  async mounted() {
    await this.loadCurrentLocation();
    await this.loadAppointments();
  },
  methods: {
    ...mapActions("session", ["loadCurrentLocation"]),
    ...mapActions("appointments", ["loadAppointments"]),

    async checkNextAppointment() {
      this.loading = true;
      var result = await scheduleEvent.isPatientOutstandingBalance(
        this.patientId
      );
      if (result != "") {
        this.showPayBalanceWarning(
          "Please pay your previous balance before confirming the appointment",
          "checkIn"
        );
        this.loading = false;
      } else {
        this.setCheckIn();
      }
    },
    async joinTelehealthSession() {
      this.loading = true;
      var result = await scheduleEvent.isPatientOutstandingBalance(
        this.patientId
      );
      if (result != "") {
        this.showPayBalanceWarning(
          "Please pay your previous balance before joining the session."
        );
        this.loading = false;
      } else {
        this.openTeleHealthSession();
      }
    },
    async showPayBalanceWarning(title, action) {
      this.$dialog
        .confirm(
          {
            title: title
          },
          {
            view: "payment-options-confirm",
            options: [{ value: true, label: "Yes" }]
          }
        )
        .then(async option => {
          if (option.data === "payNow") {
            var response = await billingServer.getInvoices(this.patientId);
            this.$router.push({
              name: "InvoicePayment",
              params: {
                invoices: response.data,
                fromPaywall: true
              }
            });
          } else {
            if (action === "checkIn") {
              this.setCheckIn();
            } else {
              this.openTeleHealthSession();
            }
          }
        })
        .catch(function() {});
    },
    openTeleHealthSession() {
      let url;
      if (
        this.nextAppointment.teamsMeetingUrl !== undefined &&
        this.nextAppointment.teamsMeetingUrl != null &&
        this.nextAppointment.teamsMeetingUrl !== ""
      ) {
        url = this.nextAppointment.teamsMeetingUrl;
      }
      if (
        this.nextAppointment.zoomMeetingUrl !== undefined &&
        this.nextAppointment.zoomMeetingUrl != null &&
        this.nextAppointment.zoomMeetingUrl !== ""
      ) {
        url = this.nextAppointment.zoomMeetingUrl;
      }
      window.open(url, "_blank");
      this.loading = false;
    },
    async setCheckIn() {
      var checkInResult = await scheduleEvent.setCheckedIn(
        this.nextAppointment.episodeOfCareId,
        {
          checkedIn: !this.nextAppointment.checkedIn
        }
      );
      this.nextAppointment.checkedIn = checkInResult.checkedIn;
      this.loading = false;
    }
  },
  computed: {
    ...mapGetters("appointments", [
      "appointments",
      "nextAppointment",
      "lastAppointment"
    ]),
    ...mapState("session", {
      patientId: state => state.user.PatientId
    })
  }
};
</script>

<style>
.btn-success,
.btn-warning {
  color: white !important;
}
.check-success {
  color: rgb(133, 133, 133) !important;
  background-color: inherit;
}
.gap-appointments {
  margin-left: 50px;
}
</style>
